module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "menuIcon.fb1f72dc.png";